import { useState } from 'react'
import { actionType } from '../context/reducer'
import { useStateValue } from '../context/StateProvider'
import styles from '../styles/EarnCard.module.css'
import { truncateAddress } from '../utils'
export const ReferralCard = () => {
    
    const [{user}, dispatch ] = useStateValue()
    const [ add, setAdd ] = useState("")
    const link = 'https://maticvault.app'

    const copyToClipboard = () => {
        console.log("copied");
    }

    const managerAddress = (e) => {
        console.log(e.target.value)
        setAdd(e.target.value)
    }

    const submitAddress = () => {
        console.log("address",add)
        dispatch({
            type: actionType.SET_REF,
            refAddress: add
        })
    }
    return (
    <div className={styles.refCard}>
        <div>
            <input onChange={managerAddress} className={styles.inp} type='text' placeholder='Your Manager`s Wallet Address' />
            <button onClick={submitAddress} className={styles.btn}>Sumbit Address</button>
        </div>
        <div>
            <h1 className={styles.h}>Your Referral Code</h1>
            <div className={styles.grp}>
                <p className={styles.pp}>{user}</p>
                <button onClick={copyToClipboard} className={styles.btn1}>Copy to Clipboard</button>
            </div>
        </div>
    </div>
    )
}